import React from 'react';
import { Table, Skeleton } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Box, LinearProgress } from '@mui/material';

interface Props {
  loading: boolean;
  dataSource: any[];
  columns: ColumnsType<any>;
  rowSelection?: object;
  progressValue: number;
  isProcessing: boolean;
}

export const AgencyTable: React.FC<Props> = ({ loading, dataSource, columns, rowSelection, progressValue, isProcessing }) => {
  return (
    <Box>
      <Box sx={{ width: '100%', mb: 1.5 }}>
        {(progressValue > 0 || isProcessing) && (
          <LinearProgress variant="determinate" value={progressValue} sx={{ height: 8, borderRadius: 4 }} />
        )}
      </Box>
      {loading ? (
        <Skeleton active paragraph={{ rows: 5 }} />
      ) : (
        <Table
          size="small"
          bordered
          dataSource={dataSource}
          columns={columns}
          rowSelection={rowSelection}
          scroll={{ y: 400, x: 1000 }}
          pagination={false}
          rowClassName={() => 'agency-row'}
          style={{ fontSize: 12 }}
        />
      )}
    </Box>
  );
};